<template>
  <div class="d-flex align-center mb-3 z-4">
    <div class="cursor" @click="breadCrumbs(1)">
      <p class="default_txt">Course</p>
    </div>
    <v-icon small>mdi-chevron-right</v-icon>
    <div class="cursor" @click="breadCrumbs(2)">
      <p class="default_txt">Class</p>
    </div>
    <v-icon small>mdi-chevron-right</v-icon>
    <div class="cursor" @click="breadCrumbs(3)">
      <p class="default_txt">Section</p>
    </div>
    <v-icon small>mdi-chevron-right</v-icon>
    <p class="small_txt ma-0 color_default cursor"><b>Module</b></p>
  </div>
</template>

<script>
export default {
  name: "breadcrumbSection",
  methods: {
    breadCrumbs(q) {
      switch (q) {
        case 1:
          this.$router.push("/course/cr/list");
          break;
        case 2:
          this.$router.push(`/course/inclass/${this.$route.params.idCourse}`);
          break;
        case 3:
          this.$router.push(
            `/section/inclass/${this.$route.params.idSection}/${this.$route.params.idCourse}`
          );
          break;
      }
    },
  },
};
</script>

<style>
</style>